const aboutData = [
  {
    dataId: "aboutUs",
    firstTitle: " מי אנחנו ",
    thumbnail: "/hero2.png",
    firstParagraph: [
      `בבית המדרש "צדקו יחדיו" אנו עוסקים בסלילת דרך שבה מתאחדים התלמודים, הבבלי והירושלמי.

החשיבות של שילוב התלמוד הירושלמי בליבת העסק התלמודי של דורנו, מובנת מאליה. מאז שהתחלנו להכות שורשים בארצנו במאה וחמישים שנה האחרונות, הולך הירושלמי ומתגלה, קימעא קימעא.

תלמוד זה חיכה לנו בכל שנות גלותנו, אל העת בו יכירו באוצרותיו.

יש לציין, שהרב קוק ציין הרבה פעמים את שילוב הירושלמי בלימוד כיעד מספר אחד של הקמת ישיבתו "מרכז הרב".

הרב חרל"פ כתב על כך דברים מרוממים (מעייני הישועה פרק לט):

"אם ממזגים את התלמוד הירושלמי עם התלמוד הבבלי, מביאים בזה אורה וברכה ומקרבים את הגאולה. ותלמידי חכמים כאלה, העוסקים במזוג הזה, הם הם תלמידי החכמים האמיתים, המרבים שלום ונעם בעולם, והם מבטלים כל קטטה ומריבה מן העולם...

אם משיח בן יוסף יבוא לפני משיח בן דוד, עלול להיות שהאור המבהיק של הגאולה יגיה מתוך חשך גדול וצער עגום חלילה, כתלמוד הבבלי המאיר מתוך מחשכים, "במחשכים הושיבני זה תלמודה של בבל" (סנהדרין שם), אולם אם יתמזג תלמוד בבלי עם תלמוד ירושלמי, שעליו נאמר "על הגאולה זה תלמוד ירושלמי" (זוהר חדש רות), תצמח מזה קרן ישועה, ומשיח בן דוד יבוא מקודם, ומשיח בן יוסף יהיה שלוחו, והגאולה תהיה ברחמים גלויים וגדולים."

אנו מפעילים גם בית מדרש וירטואלי, בו לומדים כעשרה לומדים. מסגרת הלימוד היא 5-8 ש"ש, עם קשר במיילים ובקבוצה יעודית בוואטספ, וכן מפגשים בזום. יחד אנו מלבנים את הסוגיות בשני התלמודים זה לעומת זה, מתוך מגמה להבין את האור המיוחד של תורת ארץ ישראל, ומתוך כך את מקומם וחשיבותם של שני התלמודים בעיצוב התורה הממוזגת הזאת.

ראש בית המדרש עוסק בסיכום ההבדלים באופן שיטתי ועקבי, סוגיא אחר סוגיא, וביאורם על פי כללים ועקרונות מתוך תורת הנסתר ודברי הרב קוק, המבארים את סגולת אורה של ארץ ישראל. המטרה היא להגיש לפני הציבור את התורה הזאת.

בנוסף אנו משתדלים להפיץ בציבור הרחב את הבשורה, בשיעורים בקהילות ובישיבות וכן בקבוצות וואטספ וכדומה, וכמובן גם על ידי האתר הזה.

"אין תורה כתורת ארץ ישראל".
`,
    ],

    images: [
      "/mizug-img1.jpeg",
      "/mizug-img1.jpeg",
      "/mizug-img1.jpeg",
      "/mizug-img1.jpeg",
    ],
  },
  {
    dataId: "team",
    firstTitle: "צוות בית המדרש",
    thumbnail: "/mizug-img1.jpeg",
    firstParagraph: [
      `בבית המדרש "צדקו יחדיו" אנו עוסקים בסלילת דרך שבה מתאחדים התלמודים, הבבלי והירושלמי.

החשיבות של שילוב התלמוד הירושלמי בליבת העסק התלמודי של דורנו, מובנת מאליה. מאז שהתחלנו להכות שורשים בארצנו במאה וחמישים שנה האחרונות, הולך הירושלמי ומתגלה, קימעא קימעא.

תלמוד זה חיכה לנו בכל שנות גלותנו, אל העת בו יכירו באוצרותיו.

יש לציין, שהרב קוק ציין הרבה פעמים את שילוב הירושלמי בלימוד כיעד מספר אחד של הקמת ישיבתו "מרכז הרב".

הרב חרל"פ כתב על כך דברים מרוממים (מעייני הישועה פרק לט):

"אם ממזגים את התלמוד הירושלמי עם התלמוד הבבלי, מביאים בזה אורה וברכה ומקרבים את הגאולה. ותלמידי חכמים כאלה, העוסקים במזוג הזה, הם הם תלמידי החכמים האמיתים, המרבים שלום ונעם בעולם, והם מבטלים כל קטטה ומריבה מן העולם...

אם משיח בן יוסף יבוא לפני משיח בן דוד, עלול להיות שהאור המבהיק של הגאולה יגיה מתוך חשך גדול וצער עגום חלילה, כתלמוד הבבלי המאיר מתוך מחשכים, "במחשכים הושיבני זה תלמודה של בבל" (סנהדרין שם), אולם אם יתמזג תלמוד בבלי עם תלמוד ירושלמי, שעליו נאמר "על הגאולה זה תלמוד ירושלמי" (זוהר חדש רות), תצמח מזה קרן ישועה, ומשיח בן דוד יבוא מקודם, ומשיח בן יוסף יהיה שלוחו, והגאולה תהיה ברחמים גלויים וגדולים."

אנו מפעילים גם בית מדרש וירטואלי, בו לומדים כעשרה לומדים. מסגרת הלימוד היא 5-8 ש"ש, עם קשר במיילים ובקבוצה יעודית בוואטספ, וכן מפגשים בזום. יחד אנו מלבנים את הסוגיות בשני התלמודים זה לעומת זה, מתוך מגמה להבין את האור המיוחד של תורת ארץ ישראל, ומתוך כך את מקומם וחשיבותם של שני התלמודים בעיצוב התורה הממוזגת הזאת.

ראש בית המדרש עוסק בסיכום ההבדלים באופן שיטתי ועקבי, סוגיא אחר סוגיא, וביאורם על פי כללים ועקרונות מתוך תורת הנסתר ודברי הרב קוק, המבארים את סגולת אורה של ארץ ישראל. המטרה היא להגיש לפני הציבור את התורה הזאת.

בנוסף אנו משתדלים להפיץ בציבור הרחב את הבשורה, בשיעורים בקהילות ובישיבות וכן בקבוצות וואטספ וכדומה, וכמובן גם על ידי האתר הזה.

"אין תורה כתורת ארץ ישראל".
`,
    ],

    images: [
      "/mizug-img1.jpeg",
      "/mizug-img1.jpeg",
      "/mizug-img1.jpeg",
      "/mizug-img1.jpeg",
      "/mizug-img1.jpeg",
    ],
  },
];

export default aboutData;
